import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProfileHistoryPage } from '@/app/(client)/network/-components/companyProfileTabs/history/ProfileHistoryPage';
import { useProfileHistoryPage } from '@/app/(client)/network/-hooks/useProfileHistoryPage';

const searchSchema = z.object({
  templateId: z.string().optional(),
});

/**
 * The Profile History page (DELTA-2485). Reached from the "View Profile
 * History" link in the company header — like v1, a page of its own under the
 * company header rather than a tab, so it is deliberately absent from the tab
 * list in `route.tsx`.
 */
export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/history',
)({
  validateSearch: searchSchema,
  component: HistoryRoute,
});

function HistoryRoute() {
  const { companyId } = Route.useParams();
  const page = useProfileHistoryPage(companyId);

  return (
    <ProfileHistoryPage
      entries={page.entries}
      templateId={page.templateId}
      templateOptions={page.templateOptions}
      onTemplateChange={page.setTemplateId}
      isLoading={page.isLoading}
      isError={page.isError}
      hasNextPage={page.hasNextPage}
      isFetchingNextPage={page.isFetchingNextPage}
      onLoadMore={page.loadMore}
      t={page.t}
    />
  );
}
